import React from 'react'
import { Grid, Typography } from '@mui/material'

function InvalidPrivileges() {
  return (
    <Grid container display='flex' direction='row' alignItems='center' justifyContent='center' position='relative' sx={{backgroundColor:'#181824', pt:1, height:'90vh'}}>
        <Grid item container justifyContent='center'>
            <Typography variant='h1' color='#FFF' fontSize={{xs: 35, md:100}} fontWeight='bold'>RESTRICTED ACCESS</Typography>
        </Grid>
    </Grid>
  )
}

export default InvalidPrivileges